import request from '../request';

// 获取广告banner
export function getAdvertList() {
    return request('/advert/getAdvertList', {
        method: 'GET'
    });
}

// 获取广告详情
export function getAdvertDetail(params) {
    return request('/advert/getAdvertById', {
        method: 'GET',
        params
    });
}
